export default Object.freeze({
    SEARCH: {
        name: 'Search',
        route: '/'
    },
    ABOUT: {
        name: 'About',
        route: '/books/:id'
    },
    NOTFOUND: {
        name: 'NotFound',
        route: '*'
    },
});